import { Accordion, Alert, Box, Button, Card, Container, Grid, Group, Image, Select, Stack, Text, TextInput, Tooltip, useMantineTheme } from '@mantine/core';
import { HeaderSimple } from '../components/Navbar';
import { Footer } from '../components/Sections/Footer';
import axios from 'axios';
import useStore from '../store/useStore';
import { CartProductCard } from '../components/Cards';
import { useForm } from '@mantine/form';
import Wilayas from './../helper/wilayas.json';
import Communes from './../helper/communes.json';
import { useEffect, useState } from 'react';
import { IconShoppingCartFilled } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';

export function Cart() {
    const theme = useMantineTheme();
    const navigate = useNavigate();
    const [allWilayas, setAllWilayas] = useState<{ label: string; value: string }[]>([]);
    const [allCommunes, setAllCommunes] = useState<{ label: string; value: string }[]>([]);
    const [deliveryPrice, setDeliveryPrice] = useState(0);
    const [delivery, setDelivery] = useState<any>(null);
    const [minOrderQuantity, setMinOrderQuantity] = useState<number>(10);

    const [couponCodeInput, setCouponCodeInput] = useState<string>('');
    const [appliedCoupon, setAppliedCoupon] = useState<{ coupon: string; discountPercentage: number } | null>(null);
    const [couponLoading, setCouponLoading] = useState<boolean>(false);
    const [couponError, setCouponError] = useState<string | null>(null);

    const { onSubmit, reset, values, getInputProps, errors } = useForm({
        initialValues: {
            name: '',
            phone: '',
            state: '',
            city: '',
            typeFee: 'desk_fee',
            address: ''
        },
        validate: {
            name: (value: any) => (value?.length < 2 ? 'الاسم غير صالح' : null),
            phone: (value: any) => (/^(05|06|07)[0-9]{8}$/.test(value) ? null : 'رقم الهاتف غير صالح'),
            state: (value: any) => (parseInt(value) <= 0 || !value ? 'لم تختار ولاية بعد' : null),
            city: (value: any) => (parseInt(value) <= 0 || !value ? 'لم تختار بلدية بعد' : null),
            typeFee: (value: any) => (value?.length < 2 ? 'لم تختار نوع التوصيل بعد' : null),
        },
        validateInputOnBlur: true,
        validateInputOnChange: true
    });

    const updateCartQuantity = useStore((state: any) => state.updateCartQuantity);
    const carts = useStore((state: any) => state.getCarts());
    const deleteCartItem = useStore((state: any) => state.deleteCartItem);
    const clearCarts = useStore((state: any) => state.clearCarts);

    const [price, setPrice] = useState(0);
    const dataStore = useStore((state: any) => state.store);
    let [myIP, setMyIP] = useState<string>('');

    useEffect(() => {
        axios.get(`https://api.ipify.org/?format=json`)
            .then(({ data }) => setMyIP(data.ip))
            .catch((error) => console.log(error));

        axios.get(`${process.env.REACT_APP_API_URL}/store`)
            .then(({ data }) => {
                if (data && data.minOrderQuantity) {
                    setMinOrderQuantity(data.minOrderQuantity);
                }
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        if (Wilayas?.length > 0) {
            let newData: { label: string; value: string }[] = [];
            Wilayas?.map((item: any) => {
                newData.push({ label: item?.name, value: item?.id?.toString() });
            });
            setAllWilayas(newData);
        }
    }, []);

    useEffect(() => {
        if (carts && carts.length) {
            const newPrice = carts?.reduce((accumulator: number, item: any) => {
                return accumulator + ((item?.product?.priceAfterDiscount > 0 ? item?.product?.priceAfterDiscount : item?.product?.price) * item?.quantity);
            }, 0);

            setPrice(newPrice);
        }
    }, [carts]);

    useEffect(() => {
        if (values.state && values.state !== "") {
            if (Communes?.length > 0) {
                const filterdCommunes = Communes?.filter((item: any) => item.wilaya == values.state);
                let newData: { label: string; value: string }[] = [];
                filterdCommunes.map((item: any) => {
                    newData.push({ label: item?.name, value: item?.id?.toString() });
                });
                setAllCommunes(newData);
            }

            axios.get(`${process.env.REACT_APP_API_URL}/deliveryfees/${values.state}`)
                .then(({ data }) => {
                    setDelivery(data);
                    setDeliveryPrice((values.typeFee === "desk_fee" ? data?.desk_fee : data?.home_fee) || 0);
                })
                .catch((error) => console.log(error));
        }
    }, [values.state]);

    useEffect(() => {
        setDeliveryPrice((values.typeFee === "desk_fee" ? delivery?.desk_fee : delivery?.home_fee) || 0);
    }, [values.typeFee]);

    const totalQuantity = carts?.reduce((accumulator: any, currentValue: any) => accumulator + currentValue?.quantity, 0) || 0;

    const discountAmount = appliedCoupon ? (price * appliedCoupon.discountPercentage) / 100 : 0;
    const discountedPrice = Math.max(0, price - discountAmount);

    const handleApplyCoupon = () => {
        const code = couponCodeInput.trim();
        if (!code) {
            setCouponError('يرجى إدخال كود الكوبون');
            return;
        }

        setCouponLoading(true);
        setCouponError(null);

        axios.get(`${process.env.REACT_APP_API_URL}/coupons-has-valid/${code}`)
            .then(({ data }) => {
                setCouponLoading(false);
                if (data && data.coupon && data.discountPercentage) {
                    setAppliedCoupon({
                        coupon: data.coupon,
                        discountPercentage: Number(data.discountPercentage) || 0
                    });
                    setCouponError(null);
                } else {
                    setAppliedCoupon(null);
                    setCouponError('كود الكوبون غير صالح أو منتهي الصلاحية');
                }
            })
            .catch((error) => {
                console.log(error);
                setCouponLoading(false);
                setAppliedCoupon(null);
                setCouponError('حدث خطأ أثناء التحقق من الكوبون');
            });
    };

    const handleRemoveCoupon = () => {
        setAppliedCoupon(null);
        setCouponCodeInput('');
        setCouponError(null);
    };

    const [orderError, setOrderError] = useState<string | null>(null);

    const onSubmitForm = ({ name, phone, state, city, typeFee, address }: any) => {
        setOrderError(null);
        const allProducts: any[] = [];
        for (let i = 0; i < carts.length; i++) {
            const item = carts[i];
            const p = item?.product || item;
            const itemPrice = Number(p?.priceAfterDiscount > 0 ? p?.priceAfterDiscount : (p?.price || item?.price || 0));
            const itemQty = Number(item?.quantity || 1);
            const prodId = p?._id || p?.id || null;
            const prodName = p?.name || p?.title || item?.title || "منتج";

            allProducts.push({
                idProduct: prodId,
                name: prodName,
                price: itemPrice,
                quantity: itemQty
            });
        }

        const stateName = allWilayas.filter((item: any) => item.value === state);
        const cityName = allCommunes.filter((item: any) => item.value === city);

        axios.post(`${process.env.REACT_APP_API_URL}/orders`, {
            "fullName": name,
            "phone": phone,
            "state": stateName[0]?.label || "",
            "city": cityName[0]?.label || "",
            "typeFee": typeFee,
            "address": address,
            "deliveryPrice": deliveryPrice,
            "ipAddress": myIP,
            "price": discountedPrice,
            "coupon": appliedCoupon?.coupon || "",
            "discountCoupon": appliedCoupon?.discountPercentage || 0,
            products: allProducts
        })
            .then(({ data }) => {
                navigate(`/order/confirmed`);
                onReset();
            })
            .catch((error) => {
                console.log(error);
                const errMsg = error?.response?.data?.message || 'حدث خطأ أثناء تقديم الطلب';
                setOrderError(errMsg);
            });
    };

    const deleteItemFromLocalStorage = (index: any) => {
        deleteCartItem(index);
    };

    const changeQuantityItemFromLocalStorage = (index: any, valueAdd: number) => {
        updateCartQuantity(index, valueAdd);
    };

    const onReset = () => {
        reset();
        setPrice(0);
        clearCarts();
        setDelivery(null);
        setDeliveryPrice(0);
        setAppliedCoupon(null);
        setCouponCodeInput('');
        setCouponError(null);
    };

    return (
        <>
            <HeaderSimple />
            <Container size={'lg'} mt={130}>
                <Grid gutter="xl" mt={50}>
                    {carts?.length > 0 ?
                        <>
                            <Grid.Col span={{ base: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
                                {carts?.map((item: any, index: number) => (
                                    <CartProductCard
                                        key={index} index={index}
                                        title={item?.product?.title}
                                        image={item?.product?.image}
                                        price={item?.product?.priceAfterDiscount > 0 ? item?.product?.priceAfterDiscount : item?.product?.price}
                                        priceAfterDiscount={item?.product?.priceAfterDiscount}
                                        quantity={item?.quantity}
                                        hasOffer={item?.product?.hasOffer || false}
                                        changeQuantityItemFromLocalStorage={changeQuantityItemFromLocalStorage}
                                        deleteItemFromLocalStorage={deleteItemFromLocalStorage}
                                    />
                                ))}
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, sm: 12, md: 7, lg: 7, xl: 7 }}>
                                {totalQuantity < minOrderQuantity && (
                                    <Alert mb={10} variant={'light'} color={'blue'} title={`إجمالي الكمية يجب أن يكون أكبر أو يساوي ${minOrderQuantity}`} />
                                )}
                                {orderError && (
                                    <Alert mb={15} variant="filled" color="red" title="خطأ في الطلب">
                                        {orderError}
                                    </Alert>
                                )}
                                <Card dir='rtl' withBorder radius="md" p={30} style={{ border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}` }}>
                                    <Text ta={'center'} fw={700} >أضف معلوماتك في الأسفل لإكمال الطلب</Text>

                                    <form onSubmit={onSubmit(onSubmitForm)}>
                                        <Grid mt={30}>
                                            <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                                                <TextInput
                                                    placeholder="الاسم الكامل"
                                                    size='lg'
                                                    styles={{
                                                        input: {
                                                            border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                        },
                                                    }}
                                                    {...getInputProps('name')}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                                                <TextInput
                                                    placeholder="رقم الهاتف"
                                                    size='lg'
                                                    styles={{
                                                        input: {
                                                            border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                        },
                                                    }}
                                                    {...getInputProps('phone')}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                                                <Select
                                                    placeholder="الولاية"
                                                    data={allWilayas}
                                                    size='lg'
                                                    styles={{
                                                        input: {
                                                            border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                        },
                                                        dropdown: {
                                                            boxShadow: "0px 1px 11px 2px rgb(0 0 0/15%)"
                                                        }
                                                    }}
                                                    {...getInputProps('state')}
                                                    allowDeselect={false}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                                                <Select
                                                    placeholder="البلدية"
                                                    data={allCommunes}
                                                    size='lg'
                                                    styles={{
                                                        input: {
                                                            border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                        },
                                                        dropdown: {
                                                            boxShadow: "0px 1px 11px 2px rgb(0 0 0/15%)"
                                                        }
                                                    }}
                                                    {...getInputProps('city')}
                                                    allowDeselect={false}
                                                />
                                            </Grid.Col>

                                            <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                                                <TextInput
                                                    placeholder="العنوان"
                                                    size='lg'
                                                    styles={{
                                                        input: {
                                                            border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                        },
                                                    }}
                                                    {...getInputProps('address')}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={{ base: 12, sm: 12, md: 6 }}>
                                                <Select
                                                    placeholder="نوع التوصيل"
                                                    data={[
                                                        { label: "توصيل للمكتب", value: "desk_fee" },
                                                        { label: "توصيل للبيت", value: "home_fee" }
                                                    ]}
                                                    size='lg'
                                                    styles={{
                                                        input: {
                                                            border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                        },
                                                        dropdown: {
                                                            boxShadow: "0px 1px 11px 2px rgb(0 0 0/15%)"
                                                        }
                                                    }}
                                                    {...getInputProps('typeFee')}
                                                    allowDeselect={false}
                                                />
                                            </Grid.Col>

                                            <Grid.Col span={{ base: 12, sm: 12, md: 12 }}>
                                                <Box mb={5}>
                                                    <Text fw={700} size="sm" mb={6} c="gray.7">كود الخصم (الكوبون)</Text>
                                                    {appliedCoupon ? (
                                                        <Alert color="green" variant="light" p="xs" title={`تم تطبيق الكوبون بنجاح (${appliedCoupon.coupon})`}>
                                                            <Group justify="space-between" align="center">
                                                                <Text size="sm">خصم {appliedCoupon.discountPercentage}% على المنتجات</Text>
                                                                <Button size="xs" color="red" variant="subtle" onClick={handleRemoveCoupon}>إلغاء الكوبون</Button>
                                                            </Group>
                                                        </Alert>
                                                    ) : (
                                                        <Group align="flex-start" gap="xs">
                                                            <TextInput
                                                                placeholder="أدخل كود الكوبون"
                                                                size="md"
                                                                value={couponCodeInput}
                                                                onChange={(e) => setCouponCodeInput(e.currentTarget.value)}
                                                                style={{ flex: 1 }}
                                                                styles={{
                                                                    input: {
                                                                        border: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d`
                                                                    }
                                                                }}
                                                                error={couponError}
                                                            />
                                                            <Button
                                                                onClick={handleApplyCoupon}
                                                                loading={couponLoading}
                                                                size="md"
                                                                color={dataStore?.information?.backgroundColor || "#645cbb"}
                                                                c={dataStore?.information?.textColor || "#fff"}
                                                            >
                                                                تطبيق
                                                            </Button>
                                                        </Group>
                                                    )}
                                                </Box>
                                            </Grid.Col>

                                            <Grid.Col span={{ base: 12, sm: 12, md: 12 }}>
                                                <Tooltip label={`إجمالي الكمية أقل من ${minOrderQuantity}، يجب أن يكون أكبر أو يساوي ${minOrderQuantity}`} disabled={totalQuantity >= minOrderQuantity}>
                                                    <Button
                                                        type='submit' fullWidth variant="filled"
                                                        size='lg' color={dataStore?.information?.backgroundColor || "#645cbb"}
                                                        disabled={
                                                            Object.keys(errors)?.length > 0 ||
                                                            totalQuantity < minOrderQuantity
                                                        }
                                                        c={dataStore?.information?.textColor || "#fff"}
                                                    >انقر هنا لتأكيد الطلب (الدفع عند الاستلام)</Button>
                                                </Tooltip>
                                            </Grid.Col>
                                        </Grid>
                                    </form>

                                    <Accordion
                                        mt={20} dir='rtl' variant="filled" defaultValue="1"
                                        style={{ background: theme.colors.gray[0] }}
                                        styles={{
                                            label: {
                                                fontWeight: 700,
                                                color: theme.colors.gray[7]
                                            },
                                            icon: {
                                                color: theme.colors.gray[5]
                                            },
                                            content: {
                                                padding: 0
                                            }
                                        }}
                                    >
                                        <Accordion.Item value="1" style={{ background: theme.colors.gray[0] }}>
                                            <Accordion.Control style={{ borderBottom: `2px solid ${dataStore?.information?.backgroundColor || "#645cbb"}7d` }} icon={<IconShoppingCartFilled size={26} />}>ملخص الطلب</Accordion.Control>
                                            <Accordion.Panel p={10}>
                                                <Stack gap={0}>
                                                    <Stack style={{ borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#645cbb"}7d` }} py={10}>
                                                        {carts?.map((item: any, index: number) => (
                                                            <Group justify='space-between' py={0} key={index}>
                                                                <Text flex={3} fw={700} c={"gray.7"} >{item?.product?.title}</Text>

                                                                <Text flex={1} fw={700} c={"gray.7"} >
                                                                    <Text span={true} size='xs' fw={700} c={theme.white} bg={dataStore?.information?.backgroundColor || "#645cbb"} p={2} >{item?.quantity}×</Text> {" "}
                                                                    {((item?.product?.priceAfterDiscount > 0 ? item?.product?.priceAfterDiscount : item?.product?.price) * item?.quantity)?.toFixed(2)} د.ج
                                                                </Text>
                                                            </Group>
                                                        ))}
                                                    </Stack>
                                                    <Group justify='space-between' align='center' style={{ borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#645cbb"}7d` }} py={10}>
                                                        <Text flex={3} fw={700} c={"gray.7"} >مجموع سعر المنتجات</Text>
                                                        <Box flex={1}>
                                                            <Text fw={700} size='sm' c={"gray.7"}>{price?.toFixed(2)} د.ج</Text>
                                                        </Box>
                                                    </Group>

                                                    {appliedCoupon && (
                                                        <Group justify='space-between' align='center' style={{ borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#645cbb"}7d` }} py={10}>
                                                            <Text flex={3} fw={700} c={"green.7"} >الخصم (كوبون {appliedCoupon.coupon} - {appliedCoupon.discountPercentage}%)</Text>
                                                            <Box flex={1}>
                                                                <Text fw={700} size='sm' c={"green.7"}>-{discountAmount?.toFixed(2)} د.ج</Text>
                                                            </Box>
                                                        </Group>
                                                    )}

                                                    <Group justify='space-between' align='center' style={{ borderBottom: `2px dotted ${dataStore?.information?.backgroundColor || "#645cbb"}7d` }} py={10}>
                                                        <Text flex={3} fw={700} c={"gray.7"} >سعر التوصيل</Text>
                                                        <Box flex={1}>
                                                            <Text fw={700} size='sm' maw={"fit-content"} c={theme.white} bg={dataStore?.information?.backgroundColor || "#645cbb"} p={5} >{deliveryPrice} د.ج</Text>
                                                        </Box>
                                                    </Group>
                                                    <Group justify='space-between' py={10}>
                                                        <Text flex={3} fw={700} c={"gray.7"} >السعر الإجمالي</Text>

                                                        <Box flex={1}>
                                                            <Text fw={700} c={dataStore?.information?.backgroundColor || "#645cbb"} >
                                                                {Math.round(discountedPrice + deliveryPrice)} د.ج
                                                            </Text>
                                                        </Box>
                                                    </Group>
                                                </Stack>
                                            </Accordion.Panel>
                                        </Accordion.Item>
                                    </Accordion>
                                </Card>
                            </Grid.Col>
                        </>
                        : <Grid.Col span={12}>
                            <Stack align='center' justify='center' mt={50}>
                                <Image src={"/shopping-trolley.png"} h={"100px"} w={"100px"} fit='contain' />
                                <Text size='xl' fw={600}>لا يوجد منتجات في سلتك</Text>
                                <Button
                                    size='md' fw={700} mt={5} variant='light'
                                    color={dataStore?.information?.backgroundColor || "#645cbb"}
                                    component={Link} to={`/`}
                                >تسوق الان</Button>
                            </Stack>
                        </Grid.Col>
                    }
                </Grid>
            </Container>
            <Footer />
        </>
    );
}